import React from 'react';
import MaxWidthContainer from 'components/MaxWidthContainer';
import { MixpanelConfig } from 'utils/mixpanelConfig';

const HomeSignupSteps = () => {
  return (
    <div className="bg-[#F5F5F5] pb-8 pt-10 text-[#111928] lg:pb-[64px] lg:pt-[82px]">
      <MaxWidthContainer
        noPending
        className="flex flex-col items-center px-4 lg:px-0"
      >
        <p className="text-center text-xl font-bold lg:text-2xl">
          2 分鐘完成註冊 <br className="lg:hidden" />
          即時解鎖會員福利！
        </p>
        <div className="mt-11 grid grid-cols-2 gap-x-7 gap-y-8 px-7 lg:mt-[82px] lg:grid-cols-4 lg:gap-x-12 lg:px-0">
          {[
            {
              title: '免費註冊',
              description: '所有資料保密，無滋擾聯絡。',
            },
            {
              title: '完成皮膚檔案',
              description: '於會員專區完成 「詳細皮膚檔案」 獲取額外積分。',
            },
            {
              title: '留評價賺積分',
              description: '分享你的美妝體驗，留評價賺取積分！',
            },
            {
              title: '積分好禮 Get！',
              description: '✦$1 Sorra 積分兌 HK$1，換取品牌好物。',
            },
          ].map((o, idx) => {
            return (
              <div
                key={idx}
                className="flex w-full flex-col items-center text-base lg:w-[188px] lg:text-xl"
              >
                <img
                  src={`/images/signup-steps/${idx + 1}.png`}
                  className="h-[86px] object-contain lg:h-[100px]"
                />
                <p className="mt-6 text-center">第 {idx + 1} 步</p>
                <p className="text-center text-base font-bold lg:text-2xl">
                  {o.title}
                </p>
                <br />
                <p className="text-center">{o.description}</p>
              </div>
            );
          })}
        </div>
        <button
          className="mt-8 h-[48px] w-full rounded-[8px] bg-sorra-pink text-base font-medium text-[#fff] lg:mt-[75px] lg:w-[300px]"
          onClick={() => {
            MixpanelConfig.track('signinup_from_membership_CTA');
            window.location.href = '/login';
          }}
        >
          免費註冊
        </button>
      </MaxWidthContainer>
    </div>
  );
};

export default HomeSignupSteps;
